import React from "react";
import { connect } from "react-redux";

import { campaignActions, locationActions } from "../_actions";

import { AppMenu } from "../AppMenu";
import Dashboard from "./Dashboard";

import "./HomePage.css";

class HomePage extends React.Component {
    componentDidMount() {
        this.props.dispatch(campaignActions.getAll());
        // this.props.dispatch(locationActions.getCities()); // TODO: should request once right after logging in
        this.props.dispatch(locationActions.getDistricts(286)); // TODO: should request once right after logging in
    }

    render() {
        const { campaigns, location } = this.props;

        if (campaigns.reload) {
            this.props.dispatch(campaignActions.getAll());
        }
        return (
            <div>
                <AppMenu location={location} />
                <Dashboard />
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { users, authentication, campaigns } = state;
    const { user } = authentication;
    return {
        user,
        users,
        campaigns
    };
}

const connectedHomePage = connect(mapStateToProps)(HomePage);
export { connectedHomePage as HomePage };



// WEBPACK FOOTER //
// ./src/HomePage/HomePage.jsx